import styled from "styled-components";
import { device } from "../../globalStyles/breakpoints";

export const FlexTable = styled.div`
  > * {
    word-break: break-word;
    display: flex;
    justify-content: space-between;
    padding: 12px 16px;
    &:nth-child(n) {
      background-color: rgba(231, 234, 237, 1);
    }
    &:nth-child(2n) {
      background-color: rgba(255, 255, 255, 0);
    }
    > * {
      &:nth-child(2n) {
        text-align: right;
      }
    }
  }
  > a {
    line-height: 1;
    color: inherit;
    text-decoration: none;
  }
`;

export const ResponsiveTable = styled.table`
  margin: 1em 0;
  min-width: 300px; /* adjust to your needs */
  width: 100%;
  table-layout: fixed;

  tr {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    &:nth-child(even) {
      background-color: #f2f2f2;
    }
  }

  th {
    display: none; /* for accessibility, use a visually hidden method here instead! Thanks, reddit! */
    ${device.tablet} {
      text-align: left;
      background-color: gray;
      color: white;
    }
  }

  td {
    display: flex;
    align-items: center;
    padding: 0 20px 15px;

    &:first-child {
      padding-top: 15px;
    }

    &:before {
      content: attr(data-th) ": "; /* who knew you could do this? The internet, that's who. */
      font-weight: bold;

      /* optional stuff to make it look nicer */
      width: 50%;
      display: inline-block;
      /* end options */

      ${device.tablet} {
        display: none;
      }
    }
    > span {
      display: inline-block;
      ${device.tablet} {
        display: inline;
      }
    }
  }

  th,
  td {
    text-align: left;

    ${device.tablet} {
      display: table-cell;
      padding: 0.25em 0.5em;
    }
  }
`;
